export function RectangleMinIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.667 6A.667.667 0 006 6.667v10.666c0 .369.298.667.667.667h10.666a.667.667 0 00.667-.667V6.667A.667.667 0 0017.333 6H6.667zm0-2A2.667 2.667 0 004 6.667v10.666A2.667 2.667 0 006.667 20h10.666A2.667 2.667 0 0020 17.333V6.667A2.667 2.667 0 0017.333 4H6.667z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
